// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__zvc2K","paramInput":"JobSimulator_paramInput__2-090","input":"JobSimulator_input__myI0k"};